import { render, staticRenderFns } from "./GContextMenu.vue?vue&type=template&id=f93eadc6&scoped=true&"
import script from "./GContextMenu.vue?vue&type=script&lang=js&"
export * from "./GContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./GContextMenu.vue?vue&type=style&index=0&id=f93eadc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93eadc6",
  null
  
)

export default component.exports